import React from "react";
import backgroundImgLeft from "./../../images/historyLineLeft.svg"
import backgroundImgRight from "./../../images/historyLineRight.svg"

interface HistorySectionProps {
  header: string; // Hauptüberschrift
  subHeader: string; // Unterüberschrift
  content: string; // Textinhalt
  imageUrl: string; // URL des Bildes
  imageDescription: string; // Beschreibung des Bildes
  imageSize?: React.CSSProperties; // Größenangabe des Bildes
  direction: "left" | "right"; // Artikel-Ausrichtung (links/rechts)
  afterAlign: "left" | "right" | "none"; // Ausrichtung der Linie
  windowWidth: number;
}

const HistorySection: React.FunctionComponent<HistorySectionProps> = ({
  header,
  subHeader,
  content,
  imageUrl,
  imageDescription,
  imageSize = { width: "100%", height: "auto" },
  direction,
  afterAlign,
  windowWidth,
}) => {
  const rowStyle: React.CSSProperties = {
    display: windowWidth > 670 ? "flex" : "block",
    flexDirection: direction === "left" ? "row" : "row-reverse",
    alignItems: "center",
    marginBottom: "4rem",
    position: "relative",
  };

  const contentColStyle: React.CSSProperties = {
    flex: 7,
    padding: "1rem",
    textAlign: (direction === "left" ? "right" : "left")
  };

  const imageColStyle: React.CSSProperties = {
    flex: 5,
    padding: "1rem",
    textAlign: direction,
  };

  const headerStyle: React.CSSProperties = {
    fontWeight: 700,
    fontSize: "1.5rem",
    lineHeight: "12px",
    letterSpacing: ".25em",
    display: "block",
    padding: 0,
    marginBottom: "10px",
    textTransform: "uppercase",
    color: "#c39d63",
    fontFamily: "Avenir Next Codensed Ultralight",
  };

  const subHeaderStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Ultralight",
    fontStyle: "normal",
    fontWeight: 300,
    fontSize: "64px",
    lineHeight: "62px",
    letterSpacing: ".03em",
    textTransform: "capitalize",
    color: "#514633",
    display: "block",
    marginBottom: "65px",
  };

  const contentStyle: React.CSSProperties = {
    fontFamily: "Avenir Next Codensed Regular",
    fontWeight: 300,
    fontSize: "28px",
    lineHeight: "45px",
    textTransform: "capitalize",
    letterSpacing: ".05em",
    color: "#342714"
  };
  
  const imageDescriptionStyle: React.CSSProperties = {
    fontFamily: "Cooper Lt BT",
    fontWeight: 300,
    fontSize: "40px",
    lineHeight: "53px",
    letterSpacing: ".03em",
    textTransform: "uppercase",
    color: "#514633",
    textAlign: direction,
    marginTop: "1rem",
  };

  const afterStyle: React.CSSProperties = {
    content: "''",
    background: `url(${afterAlign === "left" ? backgroundImgLeft : backgroundImgRight}) no-repeat center center`,
    display: "block",
    bottom: "-70px",
    left: afterAlign === "left" ? "0" : "auto",
    right: afterAlign === "right" ? "0" : "auto",
    margin: "auto",
    width: "469px",
    height: "239px",
  };

  return (
    <div style={{ position: "relative", marginBottom: "6rem" }}>
      <div style={rowStyle}>
        {/* Content */}
        <div style={contentColStyle}>
          <h4 style={headerStyle}>{header}</h4>
          <div style={subHeaderStyle}>{subHeader}</div>
          <p style={contentStyle}>{content}</p>
        </div>
        {/* Image */}
        {windowWidth > 670 && <div style={imageColStyle}>
          <img src={imageUrl} alt={imageDescription} style={imageSize} />
          <div style={imageDescriptionStyle}>{imageDescription}</div>
        </div>}
      </div>
      {/* After Element */}
      {windowWidth > 670 && afterAlign !== "none" && <div style={afterStyle}></div>}
    </div>
  );
};

export default HistorySection;
